"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isArray_1 = __importDefault(require("lodash/isArray"));
const trackEvent_1 = __importDefault(require("../../moengage/trackEvent"));
/**
 * push dataLayer object for gtm
 * @param {Object} data object
 *
 */
function pushDataLayer(data) {
    (0, trackEvent_1.default)(data);
    if ((0, isArray_1.default)(global.dataLayer)) {
        global.dataLayer.push(data);
    }
}
exports.default = pushDataLayer;
